export default {
  data: [{
    id: 0,
    name: 'Lite',
    type: 'small',
    price: 'Free forever',
    description: 'If you\'re just getting started and looking for a basic set of features to kickstart your e-commerce journey.',
    buttonText: 'Choose plan',
    productsAvailable: 5000,
  }, {
    id: 1,
    name: 'Essentials',
    type: 'medium',
    price: 149,
    description: 'Level up with more features & merchandising tools that will help grow your business faster.',
    buttonText: 'Choose plan',
    productsAvailable: 10000,
  }, {
    id: 2,
    name: 'Power Kit',
    type: 'large',
    price: 399,
    description: 'Our most popular plan, gives you an edge over your competition with the most powerful features & tools on the market.',
    buttonText: 'Choose plan',
    productsAvailable: 40000,
  }, {
    id: 3,
    name: 'Enterprise',
    type: 'enterprise',
    price: 'Custom',
    description: 'For companies who want to step into Hyperdrive. Enterprise-only features, unlimited everything, white glove support.',
    buttonText: 'Contact us!',
  }],
  tables: [{
    title: 'Usage',
    rows: [[
      '*5,000* products',
      '*10,000* products',
      '*40,000* products',
      '*Unlimited* products',
    ], [
      '*1,000* monthly API calls',
      '*10,000* monthly API calls',
      '*40,000* monthly API calls',
      '*Unlimited* monthly API calls',
    ]],
  }, {
    title: 'Solutions',
    rows: [[
      'Self-Learning Search',
      'Self-Learning Search',
      'Self-Learning Search',
      'Self-Learning Search',
    ], [
      false,
      false,
      'Product Recommendations',
      'Product Recommendations',
    ], [
      false,
      false,
      false,
      'Smart Collections',
    ]],
  }, {
    title: 'Analytics',
    rows: [[
      '*7*-day',
      '*30*-day',
      '*90*-day',
      '*120*-day',
    ]],
  }, {
    title: 'Tools',
    rows: [[
      'Stopword configuration',
      'Stopword configuration',
      'Stopword configuration',
      'Stopword configuration',
    ], [
      '*3* Synonyms',
      '*10* Synonyms',
      '*Unlimited* Synonyms',
      '*Unlimited* Synonyms',
    ], [
      false,
      '*2* Page Redirects',
      '*Unlimited* Page Redirects',
      '*Unlimited* Page Redirects',
    ], [
      false,
      '*2* Banners',
      '*Unlimited* Banners',
      '*Unlimited* Banners',
    ], [
      false,
      '*3* Pinning queries',
      '*Unlimited* Pinning',
      '*Unlimited* Pinning',
    ], [
      false,
      '*Discount* Stickers',
      '*Discount + Shipping* Stickers',
      '*All + Custom* Stickers',
    ], [
      false,
      false,
      'Recommended Synonyms',
      'Recommended Synonyms',
    ], [
      false,
      false,
      'Basic Rule-Based Transformations',
      'Advanced Rule-Based Transformations',
    ], [
      false,
      false,
      'Add-to-cart button plugin',
      'Add-to-cart button plugin',
    ], [
      false,
      false,
      false,
      'Dedicated onboarding focal point',
    ], [
      false,
      false,
      false,
      'Full project analysis & plan',
    ]],
  }, {
    title: 'Features',
    rows: [[
      'Smart autocomplete',
      'Smart autocomplete',
      'Smart autocomplete',
      'Smart autocomplete',
    ], [
      'Spelling mistake tolerance',
      'Spelling mistake tolerance',
      'Spelling mistake tolerance',
      'Spelling mistake tolerance',
    ], [
      'Dynamic filtering',
      'Dynamic filtering',
      'Dynamic filtering',
      'Dynamic filtering',
    ], [
      'Self-service styling',
      'Self-service styling',
      'Self-service styling',
      'Self-service styling',
    ], [
      false,
      'Custom CSS styling',
      'Custom CSS styling',
      'Custom CSS styling',
    ], [
      false,
      '“Powered by Findify” optional',
      '“Powered by Findify” optional',
      '“Powered by Findify” optional',
    ], [
      false,
      false,
      false,
      'Fully customizable UX + style',
    ]],
  }, {
    title: 'Support',
    rows: [[
      'Self-service support',
      'Email',
      'Chat & Priority Email',
      'Chat, Phone & Priority Email',
    ]],
  }, {
    title: 'User Experience Analysis',
    rows: [[
      false,
      false,
      false,
      'Complete UX Analysis',
    ]],
  }, {
    title: 'Device Responsiveness',
    rows: [[
      'Mobile, Tablet & Desktop',
      'Mobile, Tablet & Desktop',
      'Mobile, Tablet & Desktop',
      'Mobile, Tablet & Desktop',
    ]],
  }, {
    title: 'Product Sync',
    rows: [[
      '*1x* daily',
      '*2x* daily',
      '*4x* daily',
      '*Hourly* & *On-demand*',
    ]],
  }, {
    title: 'Performance',
    rows: [[
      'Cloud-based solution',
      'Globally distributed CDN',
      'Globally distributed CDN',
      'Globally distributed CDN',
    ], [
      false,
      false,
      false,
      'Redis Cache',
    ]],
  }], 
}
